import { useNavigate } from "react-router-dom";
import BackButton from "../siteSetting/components/BackButton";


const PageHeader = ({
    title,
    buttonText,
    handleShow,
    backButtonProduct,
    noneHrefButton,
    href,
    backHref,
    noneCreateButton
}) => {
    const navigate = useNavigate();

    const goBack = () => navigate(-1);
    const showBackByClick = noneHrefButton ? { onClick: goBack } : null;
    const showBackByHref = backButtonProduct
        ? {
            href:
                backHref
                    ? href
                        ? href
                        : "/"
                    : "/containerProductPage",
        }
        : null;


    return (
        <header className="ms-header" role="banner">
            <div className="ms-header__left">
                {showBackByHref ? (
                    <BackButton className="backButton" {...showBackByHref} />
                ) : showBackByClick ? (
                    <BackButton className="backButton" {...showBackByClick} />
                ) : null}
            </div>
            <h1 className="ms-header__title">{title}</h1>
            {noneCreateButton
                ? null
                : <button className="ms-header__upload" onClick={handleShow}>
                    {buttonText || 'Новый'}
                </button>}
        </header>
    )
}

export default PageHeader
